export class AssessmentTemplate {
  isStrategicPlan: boolean;
  includeCoverPageLogo: boolean;
  includeCoverPageExecutiveSummary: boolean;
  includeCoverPageDateStamp: boolean;
  includeTableOfContent: boolean;
  includeMission: boolean;
  missionCaption: string;
  includeVision: boolean;
  visionCaption: string;
  includeGoals: boolean;
  goalInstructions: string;
  goalCaption: string;
  includeGoalInitiatives: boolean;
  includeGoalBudget: boolean;
  goalBudgetCaption: string;
  goalBudgetDescription: string;
  objectiveInstructions: string;
  objectiveCaption: string;
  includeObjectivelInitiatives: boolean; //todo fix typo in remote and here!
  measureCaption: string;
  includeMethodology: boolean;
  methodologyCaption: string;
  includeEvidence: boolean;
  evidenceCaption: string;
  includeObjectiveBudget: boolean;
  objectiveBudgetCaption: string;
  objectiveBudgetDescriptionCaption: string;
  includeQualitativeTarget: boolean;
  qualitativeTargetCaption: string;
  qualitativeFindingCaption: string;
  includeMultipleQualitativeTarget: boolean;
  includeMultipleQualitativeFinding: boolean;
  qualitativeAnalysisCaption: string;
  includeQuantitativeTarget: boolean;
  quantitativeTargetCaption: string;
  quantitativeFindingCaption: string;
  includeMultipleQuantitativeTarget: boolean;
  includeMultipleQuantitativeFinding: boolean;
  quantitativeAnalysisCaption: string;
  includeImprovementsAchieved: boolean;
  improvementsAchievedCaption: string;
  includeAchievementsAchieved: boolean;
  achievementsAchievedCaption: string;
  includeRelatedProjects: boolean;
  actionPlanCaption: string;

  constructor() {
    this.isStrategicPlan = false;
    this.includeCoverPageLogo = true;
    this.includeCoverPageExecutiveSummary = true;
    this.includeCoverPageDateStamp = true;
    this.includeTableOfContent = true;
    this.includeMission = true;
    this.missionCaption = "";
    this.includeVision = true;
    this.visionCaption = "";
    this.includeGoals = true;
    this.goalInstructions = "";
    this.goalCaption = "";
    this.includeGoalInitiatives = true;
    this.includeGoalBudget = true;
    this.goalBudgetCaption = "";
    this.goalBudgetDescription = "";
    this.objectiveInstructions = "";
    this.objectiveCaption = "";
    this.includeObjectivelInitiatives = true; //todo fix typo in remote and here!
    this.measureCaption = "";
    this.includeMethodology = true;
    this.methodologyCaption = "";
    this.includeEvidence = true;
    this.evidenceCaption = "";
    this.includeObjectiveBudget = true;
    this.objectiveBudgetCaption = "";
    this.objectiveBudgetDescriptionCaption = "";
    this.includeQualitativeTarget = true;
    this.qualitativeTargetCaption = "";
    this.qualitativeFindingCaption = "";
    this.includeMultipleQualitativeTarget = true;
    this.includeMultipleQualitativeFinding = true;
    this.qualitativeAnalysisCaption = "";
    this.includeQuantitativeTarget = true;
    this.quantitativeTargetCaption = "";
    this.quantitativeFindingCaption = "";
    this.includeMultipleQuantitativeTarget = true;
    this.includeMultipleQuantitativeFinding = true;
    this.quantitativeAnalysisCaption = "";
    this.includeImprovementsAchieved = true;
    this.improvementsAchievedCaption = "";
    this.includeAchievementsAchieved = true;
    this.achievementsAchievedCaption = "";
    this.includeRelatedProjects = true;
    this.actionPlanCaption = "";
  }
}

export class AssessmentTemplateMeta{
  name: String;
  requestKey: String;
  deletable: boolean;

  constructor() {
    this.name = String();
    this.requestKey = String();
    this.deletable = false;
  }
}
